import { bikeBrandsMasterList } from "constants/index"

export const BRAND_FILTER_SHORT_NAME = "makes"
export const brandDefault = []

const sN = BRAND_FILTER_SHORT_NAME
const bD = brandDefault

export const BRAND_FILTER_CONFIG = {
  short_name: sN,
  default_values: bD,
  is_default: value => testBrandDefault(value), //right before clean up
  format_to_api: value => formatBrandForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatBrandFromURL(value) //
}

export const formatBrandForAPI = value => {
  if (value) {
      return { makes: value.join() } 
  } else {
    return {}
  }
}

export const testBrandDefault = value => {
  if (value) {
    if (value?.length > 0) {
      return false
    } else {
      return true
    }
  } else {
    return true
  }
}

export const formatBrandFromURL = value => {
  let cleanValue = null
  if (value) {
    cleanValue = value
    if (!(value instanceof Array)) {
      //if it's not an array we cast it to an array
      cleanValue = [value.toString()]
    }
    //ok so we have have an array of things, but is it part of our brandlist?
    const regex = new RegExp(bikeBrandsMasterList.join( "|" ), "i")
    for (let i = 0; i < cleanValue.length; i++) {
      if (!regex.test(cleanValue[i])) {
        cleanValue.splice(i, 1)
      }
    }
    //after we loop, let's check that we even still an array though.
    if (cleanValue.length === 0) {
      cleanValue = null
    }
  }
  return cleanValue
}
